import { z } from 'zod';

/**
 * Zod schema for the POST /suppliers/network/add request body
 * (NetworkSupplierAddBody).
 */
export const zodAddNetworkSupplierPayloadSchema = z.object({
  isRelevant: z.boolean().default(true),
  recipientCompanyId: z.uuid(),
  supplierCompanyId: z.uuid(),
});
